import React, { useState, useRef } from "react";
import addAvatar from "../../Assets/add-avatar.png";
import MovieTitleCard from "./MovieTitleCard";
import lock from "../../Assets/icon-lock.png";
import unlock from "../../Assets/icon-unlock.png";
import Button from "../../Components/Button";

const ProfileForm = (props) => {
  // console.log(props); //has data and callback
  const [formState, setFormState] = useState({ lock: true, titles: [""] });
  const [display, setDisplay] = useState("creating");
  const hiddenFileInput = useRef(null);
  const [avatar, setAvatar] = useState(null);
  const [currentMovieInput, setCurrentMovieInput] = useState([""]);
  const [titleCards, setTitleCards] = useState([]);

  const handleFormChange = (e) => {
    const value = e.target.value;
    setFormState({
      ...formState,
      [e.target.name]: value,
    });
    // console.log(formState);
  };

  const handleProfileVisibility = () => {
    setFormState({ ...formState, lock: !formState.lock });
  };

  const handleAvatarClick = (e) => {
    e.preventDefault();
    hiddenFileInput.current.click();
  };

  const handleAvatarChange = (e) => {
    e.preventDefault();
    const fileUploaded = e.target.files[0];
    const fileUrl = URL.createObjectURL(fileUploaded);
    setAvatar(fileUrl);
    setFormState({ ...formState, avatar: fileUrl });
    // console.log(formState);
  };

  const handleMovieChange = (e, indexFromFormState) => {
    const value = e.target.value;
    const list = [...formState.titles];
    // const currentMovies = [...currentMovieInput];
    // console.log(value);
    list[indexFromFormState] = value;
    // console.log(list);
    setFormState({ ...formState, titles: list });
    // makes api call every time there is a change; made movies disappear
    // props.handleCallback(list);
    // currentMovies[indexFromInput] = value;
    // console.log(currentMovieInput, currentMovies);
    // setCurrentMovieInput(currentMovies);
  };

  const handleMovieInputChange = (e, i) => {
    const value = e.target.value;
    // const list = [...formState.titles];
    const currentMovies = [...currentMovieInput];
    currentMovies[i] = value;
    // console.log(currentMovies);
    setCurrentMovieInput(currentMovies);
    // list.unshift(currentMovies);
    // list.flat();
    // console.log(value, i);
    // console.log(list);
    // setFormState({ ...formState, titles: list });
  };

  const addMovieField = (e) => {
    e.preventDefault();
    // setInputList([...inputList, { title: "" }]);
    let formStateCopy = [...formState.titles];
    // formStateCopy.push("");
    let currentMovies = [...currentMovieInput];
    formStateCopy.push(currentMovies);
    setFormState({ ...formState, titles: formStateCopy.flat() });
    // setFormState({...formState}):
    setTitleCards([...titleCards, formStateCopy.flat()]);
    // console.log(formState, titleCards);
    setCurrentMovieInput([""]);
    // console.log(props, " in profile form addMovieField");
    // props.handleCallback(formState.titles);
  };

  //in production stage, the save button will do the api calls to send to back end storage. you'd add the api call directly into this function. if successful, then do the callback. (display state to change, pass data to another component, only when successful, then setDisplay to be "display"; otherwise stay on page to navigate through the error.)
  const handleInitialSave = (e) => {
    e.preventDefault();
    setDisplay("display");
    setCurrentMovieInput([""]);
    // console.log(
    //   formState,
    //   titleCards,
    //   props,
    //   " from initial save in entry/create state"
    // );
    let titlesContent = formState.titles.filter((title) => title !== "");
    props.handleCallback(titlesContent);
  };

  //in production stage, the save button will do the api calls to send to back end storage.
  const saveEditState = (e) => {
    e.preventDefault();
    setDisplay("display");
    setCurrentMovieInput([""]);
    // console.log(formState, titleCards);
    let titlesContent = formState.titles.filter((title) => title !== "");
    props.handleCallback(titlesContent);
  };

  const editDisplayState = (e) => {
    e.preventDefault();
    setDisplay("editing");
    // console.log(formState);
    // setCurrentMovieInput([""]);
    // console.log(formState, titleCards);
  };

  const cancelTitle = (item, index) => {
    // console.log(`${item.title} at ${index} to cancel`);
    let formStateCopy = [...formState.titles];
    // console.log(formState.titles);
    formStateCopy.splice(index, 1);
    // console.log(formStateCopy);
    setFormState({ ...formState, titles: formStateCopy });
  };

  return (
    <div className="profile-form-wrapper">
      <form className="profile-form">
        {display === "display" ? (
          <div className="profile-form-saved">
            <div className="profile-avatar">
              <img
                className="avatar-preview"
                src={formState.avatar}
                alt="saved avatar icon"
              />
              <p>{formState.profileName}</p>
            </div>
            <div className="profile-details">
              <div>
                <div className="profile-location-wrapper">
                  <h3>Who are you?</h3>
                  <div className="profile-location">
                    <div>
                      <h4 className="profile-form-subheadings">Country</h4>
                      <p>{formState.country}</p>
                    </div>
                    <div>
                      <h4 className="profile-form-subheadings">State/Region</h4>
                      <p>{formState.stateRegion}</p>
                    </div>
                  </div>
                </div>
                <div className="profile-bio-wrapper">
                  <h4 className="profile-form-subheadings">About</h4>
                  <p>{formState.about}</p>
                </div>
              </div>
              <div>
                <div className="my-movies-wrapper">
                  <h3>My Movies</h3>
                  <div className="my-movies-title-cards-wrapper">
                    {formState.titles
                      .flat()
                      .filter((item) => item.length > 0)
                      .map((item, index) => (
                        <MovieTitleCard
                          title={item}
                          key={index}
                          display="display"
                        />
                      ))}
                  </div>
                </div>
                <Button
                  text="Edit your profile"
                  onClick={(e) => editDisplayState(e)}
                />
              </div>
            </div>
          </div>
        ) : (
          <>
            {display === "creating" && <h2>Create Your Profile</h2>}
            {display === "editing" && <h2>Edit Your Profile</h2>}
            {display === "creating" && formState.lock ? (
              <div className="profile-visibility-wrapper">
                <img src={lock} alt="locked" />
                <p>
                  Your profile visibility is editable after you save and
                  information is not used publicly.
                </p>
              </div>
            ) : display === "editing" && formState.lock ? (
              <div
                onClick={handleProfileVisibility}
                className="profile-visibility-wrapper"
              >
                <img src={lock} alt="locked" />
                <p>Your profile visibility is locked.</p>
              </div>
            ) : display === "editing" && formState.lock === false ? (
              <div
                onClick={handleProfileVisibility}
                className="profile-visibility-wrapper"
              >
                <img src={unlock} alt="unlocked" />
                <p>Your profile visibility is unlocked.</p>
              </div>
            ) : null}
            <label htmlFor="avatar">
              <button
                onClick={handleAvatarClick}
                className="profile-avatar profile-create"
              >
                {avatar ? (
                  <>
                    <img
                      className="avatar-preview"
                      src={avatar}
                      alt="avatar preview"
                    />
                    {display === "editing" ? (
                      <p>{formState.profileName}</p>
                    ) : (
                      <p>Profile picture chosen</p>
                    )}
                  </>
                ) : (
                  <>
                    <img src={addAvatar} alt="add avatar icon" />
                    <p>Add your profile picture</p>
                  </>
                )}
              </button>
            </label>
            <input
              type="file"
              ref={hiddenFileInput}
              name="avatar"
              accept="image/*"
              onChange={handleAvatarChange}
            />
            <div className="profile-widescreen">
              <div className="profile-about">
                <h3>Who are you?</h3>
                <label
                  className="profile-form-subheadings"
                  htmlFor="profileName"
                >
                  Name
                </label>
                <input
                  name="profileName"
                  type="text"
                  value={formState.profileName}
                  onChange={handleFormChange}
                />
                <label className="profile-form-subheadings" htmlFor="country">
                  Country
                </label>
                <select
                  name="country"
                  value={formState.country}
                  onChange={handleFormChange}
                >
                  <option value="">Choose your country</option>
                  <option value="Afganistan">Afghanistan</option>
                  <option value="Albania">Albania</option>
                  <option value="Algeria">Algeria</option>
                  <option value="American Samoa">American Samoa</option>
                  <option value="Andorra">Andorra</option>
                  <option value="Angola">Angola</option>
                  <option value="Anguilla">Anguilla</option>
                  <option value="Antigua & Barbuda">Antigua & Barbuda</option>
                  <option value="Argentina">Argentina</option>
                  <option value="Armenia">Armenia</option>
                  <option value="Aruba">Aruba</option>
                  <option value="Australia">Australia</option>
                  <option value="Austria">Austria</option>
                  <option value="Azerbaijan">Azerbaijan</option>
                  <option value="Bahamas">Bahamas</option>
                  <option value="Bahrain">Bahrain</option>
                  <option value="Bangladesh">Bangladesh</option>
                  <option value="Barbados">Barbados</option>
                  <option value="Belarus">Belarus</option>
                  <option value="Belgium">Belgium</option>
                  <option value="Belize">Belize</option>
                  <option value="Benin">Benin</option>
                  <option value="Bermuda">Bermuda</option>
                  <option value="Bhutan">Bhutan</option>
                  <option value="Bolivia">Bolivia</option>
                  <option value="Bonaire">Bonaire</option>
                  <option value="Bosnia & Herzegovina">
                    Bosnia & Herzegovina
                  </option>
                  <option value="Botswana">Botswana</option>
                  <option value="Brazil">Brazil</option>
                  <option value="British Indian Ocean Ter">
                    British Indian Ocean Ter
                  </option>
                  <option value="Brunei">Brunei</option>
                  <option value="Bulgaria">Bulgaria</option>
                  <option value="Burkina Faso">Burkina Faso</option>
                  <option value="Burundi">Burundi</option>
                  <option value="Cambodia">Cambodia</option>
                  <option value="Cameroon">Cameroon</option>
                  <option value="Canada">Canada</option>
                  <option value="Canary Islands">Canary Islands</option>
                  <option value="Cape Verde">Cape Verde</option>
                  <option value="Cayman Islands">Cayman Islands</option>
                  <option value="Central African Republic">
                    Central African Republic
                  </option>
                  <option value="Chad">Chad</option>
                  <option value="Channel Islands">Channel Islands</option>
                  <option value="Chile">Chile</option>
                  <option value="China">China</option>
                  <option value="Christmas Island">Christmas Island</option>
                  <option value="Cocos Island">Cocos Island</option>
                  <option value="Colombia">Colombia</option>
                  <option value="Comoros">Comoros</option>
                  <option value="Congo">Congo</option>
                  <option value="Cook Islands">Cook Islands</option>
                  <option value="Costa Rica">Costa Rica</option>
                  <option value="Cote DIvoire">Cote DIvoire</option>
                  <option value="Croatia">Croatia</option>
                  <option value="Cuba">Cuba</option>
                  <option value="Curaco">Curacao</option>
                  <option value="Cyprus">Cyprus</option>
                  <option value="Czech Republic">Czech Republic</option>
                  <option value="Denmark">Denmark</option>
                  <option value="Djibouti">Djibouti</option>
                  <option value="Dominica">Dominica</option>
                  <option value="Dominican Republic">Dominican Republic</option>
                  <option value="East Timor">East Timor</option>
                  <option value="Ecuador">Ecuador</option>
                  <option value="Egypt">Egypt</option>
                  <option value="El Salvador">El Salvador</option>
                  <option value="Equatorial Guinea">Equatorial Guinea</option>
                  <option value="Eritrea">Eritrea</option>
                  <option value="Estonia">Estonia</option>
                  <option value="Ethiopia">Ethiopia</option>
                  <option value="Falkland Islands">Falkland Islands</option>
                  <option value="Faroe Islands">Faroe Islands</option>
                  <option value="Fiji">Fiji</option>
                  <option value="Finland">Finland</option>
                  <option value="France">France</option>
                  <option value="French Guiana">French Guiana</option>
                  <option value="French Polynesia">French Polynesia</option>
                  <option value="French Southern Ter">
                    French Southern Ter
                  </option>
                  <option value="Gabon">Gabon</option>
                  <option value="Gambia">Gambia</option>
                  <option value="Georgia">Georgia</option>
                  <option value="Germany">Germany</option>
                  <option value="Ghana">Ghana</option>
                  <option value="Gibraltar">Gibraltar</option>
                  <option value="Great Britain">Great Britain</option>
                  <option value="Greece">Greece</option>
                  <option value="Greenland">Greenland</option>
                  <option value="Grenada">Grenada</option>
                  <option value="Guadeloupe">Guadeloupe</option>
                  <option value="Guam">Guam</option>
                  <option value="Guatemala">Guatemala</option>
                  <option value="Guinea">Guinea</option>
                  <option value="Guyana">Guyana</option>
                  <option value="Haiti">Haiti</option>
                  <option value="Hawaii">Hawaii</option>
                  <option value="Honduras">Honduras</option>
                  <option value="Hong Kong">Hong Kong</option>
                  <option value="Hungary">Hungary</option>
                  <option value="Iceland">Iceland</option>
                  <option value="Indonesia">Indonesia</option>
                  <option value="India">India</option>
                  <option value="Iran">Iran</option>
                  <option value="Iraq">Iraq</option>
                  <option value="Ireland">Ireland</option>
                  <option value="Isle of Man">Isle of Man</option>
                  <option value="Israel">Israel</option>
                  <option value="Italy">Italy</option>
                  <option value="Jamaica">Jamaica</option>
                  <option value="Japan">Japan</option>
                  <option value="Jordan">Jordan</option>
                  <option value="Kazakhstan">Kazakhstan</option>
                  <option value="Kenya">Kenya</option>
                  <option value="Kiribati">Kiribati</option>
                  <option value="Korea North">Korea North</option>
                  <option value="Korea Sout">Korea South</option>
                  <option value="Kuwait">Kuwait</option>
                  <option value="Kyrgyzstan">Kyrgyzstan</option>
                  <option value="Laos">Laos</option>
                  <option value="Latvia">Latvia</option>
                  <option value="Lebanon">Lebanon</option>
                  <option value="Lesotho">Lesotho</option>
                  <option value="Liberia">Liberia</option>
                  <option value="Libya">Libya</option>
                  <option value="Liechtenstein">Liechtenstein</option>
                  <option value="Lithuania">Lithuania</option>
                  <option value="Luxembourg">Luxembourg</option>
                  <option value="Macau">Macau</option>
                  <option value="Macedonia">Macedonia</option>
                  <option value="Madagascar">Madagascar</option>
                  <option value="Malaysia">Malaysia</option>
                  <option value="Malawi">Malawi</option>
                  <option value="Maldives">Maldives</option>
                  <option value="Mali">Mali</option>
                  <option value="Malta">Malta</option>
                  <option value="Marshall Islands">Marshall Islands</option>
                  <option value="Martinique">Martinique</option>
                  <option value="Mauritania">Mauritania</option>
                  <option value="Mauritius">Mauritius</option>
                  <option value="Mayotte">Mayotte</option>
                  <option value="Mexico">Mexico</option>
                  <option value="Midway Islands">Midway Islands</option>
                  <option value="Moldova">Moldova</option>
                  <option value="Monaco">Monaco</option>
                  <option value="Mongolia">Mongolia</option>
                  <option value="Montserrat">Montserrat</option>
                  <option value="Morocco">Morocco</option>
                  <option value="Mozambique">Mozambique</option>
                  <option value="Myanmar">Myanmar</option>
                  <option value="Nambia">Nambia</option>
                  <option value="Nauru">Nauru</option>
                  <option value="Nepal">Nepal</option>
                  <option value="Netherland Antilles">
                    Netherland Antilles
                  </option>
                  <option value="Netherlands">
                    Netherlands (Holland, Europe)
                  </option>
                  <option value="Nevis">Nevis</option>
                  <option value="New Caledonia">New Caledonia</option>
                  <option value="New Zealand">New Zealand</option>
                  <option value="Nicaragua">Nicaragua</option>
                  <option value="Niger">Niger</option>
                  <option value="Nigeria">Nigeria</option>
                  <option value="Niue">Niue</option>
                  <option value="Norfolk Island">Norfolk Island</option>
                  <option value="Norway">Norway</option>
                  <option value="Oman">Oman</option>
                  <option value="Pakistan">Pakistan</option>
                  <option value="Palau Island">Palau Island</option>
                  <option value="Palestine">Palestine</option>
                  <option value="Panama">Panama</option>
                  <option value="Papua New Guinea">Papua New Guinea</option>
                  <option value="Paraguay">Paraguay</option>
                  <option value="Peru">Peru</option>
                  <option value="Phillipines">Philippines</option>
                  <option value="Pitcairn Island">Pitcairn Island</option>
                  <option value="Poland">Poland</option>
                  <option value="Portugal">Portugal</option>
                  <option value="Puerto Rico">Puerto Rico</option>
                  <option value="Qatar">Qatar</option>
                  <option value="Republic of Montenegro">
                    Republic of Montenegro
                  </option>
                  <option value="Republic of Serbia">Republic of Serbia</option>
                  <option value="Reunion">Reunion</option>
                  <option value="Romania">Romania</option>
                  <option value="Russia">Russia</option>
                  <option value="Rwanda">Rwanda</option>
                  <option value="St Barthelemy">St Barthelemy</option>
                  <option value="St Eustatius">St Eustatius</option>
                  <option value="St Helena">St Helena</option>
                  <option value="St Kitts-Nevis">St Kitts-Nevis</option>
                  <option value="St Lucia">St Lucia</option>
                  <option value="St Maarten">St Maarten</option>
                  <option value="St Pierre & Miquelon">
                    St Pierre & Miquelon
                  </option>
                  <option value="St Vincent & Grenadines">
                    St Vincent & Grenadines
                  </option>
                  <option value="Saipan">Saipan</option>
                  <option value="Samoa">Samoa</option>
                  <option value="Samoa American">Samoa American</option>
                  <option value="San Marino">San Marino</option>
                  <option value="Sao Tome & Principe">
                    Sao Tome & Principe
                  </option>
                  <option value="Saudi Arabia">Saudi Arabia</option>
                  <option value="Senegal">Senegal</option>
                  <option value="Seychelles">Seychelles</option>
                  <option value="Sierra Leone">Sierra Leone</option>
                  <option value="Singapore">Singapore</option>
                  <option value="Slovakia">Slovakia</option>
                  <option value="Slovenia">Slovenia</option>
                  <option value="Solomon Islands">Solomon Islands</option>
                  <option value="Somalia">Somalia</option>
                  <option value="South Africa">South Africa</option>
                  <option value="Spain">Spain</option>
                  <option value="Sri Lanka">Sri Lanka</option>
                  <option value="Sudan">Sudan</option>
                  <option value="Suriname">Suriname</option>
                  <option value="Swaziland">Swaziland</option>
                  <option value="Sweden">Sweden</option>
                  <option value="Switzerland">Switzerland</option>
                  <option value="Syria">Syria</option>
                  <option value="Tahiti">Tahiti</option>
                  <option value="Taiwan">Taiwan</option>
                  <option value="Tajikistan">Tajikistan</option>
                  <option value="Tanzania">Tanzania</option>
                  <option value="Thailand">Thailand</option>
                  <option value="Togo">Togo</option>
                  <option value="Tokelau">Tokelau</option>
                  <option value="Tonga">Tonga</option>
                  <option value="Trinidad & Tobago">Trinidad & Tobago</option>
                  <option value="Tunisia">Tunisia</option>
                  <option value="Turkey">Turkey</option>
                  <option value="Turkmenistan">Turkmenistan</option>
                  <option value="Turks & Caicos Is">Turks & Caicos Is</option>
                  <option value="Tuvalu">Tuvalu</option>
                  <option value="Uganda">Uganda</option>
                  <option value="United Kingdom">United Kingdom</option>
                  <option value="Ukraine">Ukraine</option>
                  <option value="United Arab Erimates">
                    United Arab Emirates
                  </option>
                  <option value="United States of America">
                    United States of America
                  </option>
                  <option value="Uraguay">Uruguay</option>
                  <option value="Uzbekistan">Uzbekistan</option>
                  <option value="Vanuatu">Vanuatu</option>
                  <option value="Vatican City State">Vatican City State</option>
                  <option value="Venezuela">Venezuela</option>
                  <option value="Vietnam">Vietnam</option>
                  <option value="Virgin Islands (Brit)">
                    Virgin Islands (Brit)
                  </option>
                  <option value="Virgin Islands (USA)">
                    Virgin Islands (USA)
                  </option>
                  <option value="Wake Island">Wake Island</option>
                  <option value="Wallis & Futana Is">Wallis & Futana Is</option>
                  <option value="Yemen">Yemen</option>
                  <option value="Zaire">Zaire</option>
                  <option value="Zambia">Zambia</option>
                  <option value="Zimbabwe">Zimbabwe</option>
                </select>
                <label
                  className="profile-form-subheadings"
                  htmlFor="stateRegion"
                >
                  State / Region
                </label>
                <input
                  name="stateRegion"
                  type="text"
                  value={formState.stateRegion}
                  onChange={handleFormChange}
                />
                <label className="profile-form-subheadings" htmlFor="about">
                  About
                </label>
                <textarea
                  name="about"
                  type="text"
                  placeholder="Hi! Please introduce yourself"
                  value={formState.about}
                  onChange={handleFormChange}
                />
              </div>
              <div className="profile-movies">
                <h3>What have you been watching?</h3>
                <p className="profile-movies-message">
                  Movies listed here will be added to the My Movies page and can
                  be removed from your list upon edit.
                </p>
                <label className="profile-form-subheadings" htmlFor="title">
                  Add New Movie
                </label>
                {display === "creating" &&
                  formState.titles &&
                  formState.titles.map((titleItem, titleIndex) => {
                    return (
                      <div key={titleIndex} className="movie-title-input">
                        <input
                          name="title"
                          type="text"
                          value={titleItem}
                          // value={item.title}
                          onChange={(e) => handleMovieChange(e, titleIndex)}
                        />
                      </div>
                    );
                  })}
                {display === "editing" &&
                  currentMovieInput &&
                  currentMovieInput.map((inputItem, inputIndex) => {
                    return (
                      <div key={inputIndex} className="movie-title-input">
                        <input
                          name="title"
                          type="text"
                          value={inputItem}
                          // value={item.title}
                          onChange={(e) =>
                            handleMovieInputChange(e, inputIndex)
                          }
                        />
                      </div>
                    );
                  })}
                <Button text="Add movie" onClick={(e) => addMovieField(e)} />
                {/* <button
                className="btn btn-light btn-add"
                onClick={(e) => addMovieField(e)}
              > 
                Add another
              </button>*/}
                {formState.titles[0].length > 1 && display === "display" ? (
                  <div>
                    <h3>Your Movies</h3>
                    {/* this section's cards must have an x at the upper right corner when display is "editing" */}
                    {formState.titles
                      .filter((item) => item !== "")
                      .map((item, index) => (
                        <MovieTitleCard
                          title={item.Title}
                          key={index}
                          display="display"
                        />
                      ))}
                  </div>
                ) : null}
                {display === "creating" && (
                  <Button text="Save" onClick={(e) => handleInitialSave(e)} />
                )}

                {formState.titles[0].length > 1 && display === "editing" ? (
                  <div className="my-movies-wrapper">
                    <h3>Your Movies</h3>
                    <div className="my-movies-title-cards-wrapper">
                      {/* this section's cards must have an x at the upper right corner when display is "editing" */}
                      {formState.titles
                        .flat()
                        .filter((item) => item !== "")
                        .map((item, index) => (
                          <MovieTitleCard
                            title={item}
                            key={index}
                            display="editing"
                            handleCancel={(item) => cancelTitle(item, index)}
                          />
                        ))}
                    </div>
                  </div>
                ) : null}
                {display === "editing" && (
                  <Button text="Save" onClick={(e) => saveEditState(e)} />
                )}
              </div>
            </div>
          </>
        )}
      </form>
    </div>
  );
};

export default ProfileForm;
